// chakra imports
import { Box, Flex, Icon, IconButton, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useTranslation } from "react-i18next";

// FUNCTIONS

function SidebarContent(props) {
  const { routes, collapsed = false, onToggleCollapse } = props;
  const { t } = useTranslation();
  // SIDEBAR
  return (
    <Flex direction='column' height='100%' pt='25px' px="16px" borderRadius='30px'>
      {onToggleCollapse && (
        <Flex justify={collapsed ? "center" : "flex-end"} mb="4px">
          <IconButton
            aria-label={collapsed ? t("sidebar.expand") : t("sidebar.collapse")}
            icon={<Icon as={collapsed ? MdChevronRight : MdChevronLeft} width="22px" height="22px" />}
            onClick={onToggleCollapse}
            size='sm'
            variant='ghost'
            borderRadius='full'
            color='secondaryGray.500'
          />
        </Flex>
      )}
      <Brand collapsed={collapsed} />
      <Stack direction='column' mb='auto' mt='8px'>
        <Box ps={collapsed ? "0px" : "20px"} pe={collapsed ? "0px" : { md: "16px", "2xl": "1px" }}>
          <Links routes={routes} collapsed={collapsed} />
        </Box>
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
